class CanvasController {
    
}

CanvasController.canvasCallback = null;
CanvasController.heatmapType = null;

export default CanvasController;

